export default __webpack_public_path__ + "static/media/dfp-min.ea417083.png";